var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.46 40.4146H40.1597C37.9386 40.4146 35.8085 41.2969 34.238 42.8674C32.6675 44.4379 31.7852 46.568 31.7852 48.7891V107.397C31.7852 109.618 32.6675 111.748 34.238 113.318C35.8085 114.889 37.9386 115.771 40.1597 115.771H98.7674C100.988 115.771 103.119 114.889 104.689 113.318C106.26 111.748 107.142 109.618 107.142 107.397V78.0894",
    stroke: "#F79C00",
    strokeWidth: 6.89433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.856 34.1385C102.521 32.4732 104.78 31.5376 107.135 31.5376C109.49 31.5376 111.749 32.4732 113.414 34.1385C115.08 35.8038 116.015 38.0625 116.015 40.4176C116.015 42.7728 115.08 45.0315 113.414 46.6968L73.6405 86.4705L56.8984 90.6543L61.1103 73.9052L100.856 34.1385Z",
    stroke: "#F79C00",
    strokeWidth: 6.89433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPopup);
export default __webpack_public_path__ + "static/media/edit-popup.7952b54b4d18815eec1e0ac4f161b505.svg";
export { ForwardRef as ReactComponent };